export default {
  data() {
    const that = this
    return {
      commentValidateRule: [
        {
          type: 'string',
          trigger: 'change',
          transform(value) {
            return value.trim()
          },
          validator(rule, value, callback) {
            if (!value) {
              callback(new Error(that.$t('Validate.Required')))
            }
            if (value.length < 10) {
              callback(new Error(that.$t('Validate.minLength', { number: 10, type: that.$tc('Common.characters', 10) })))
            }
            const words_length = value.split(' ').length
            if (words_length < 2) {
              callback(new Error(that.$t('Validate.minLength', { number: 2, type: that.$tc('Common.words', 2) })))
            }
            callback()
          },
        }
      ]
    }
  },
  methods: {
    $_validateMinMax(min = Number.MIN_SAFE_INTEGER || -9007199254740991,
      max = Number.MAX_SAFE_INTEGER || 9007199254740991,
      required, type = 'string') {
      const that = this
      return [{
        type: type,
        required: required,
        trigger: 'change',
        min,
        message: that.$t('Validate.minLength', {number: min, type: that.$tc('Common.characters', 2) })
      },
      {
        type: type,
        required: required,
        trigger: 'change',
        max,
        message: that.$t('Validate.maxLength', {number: max, type: that.$tc('Common.characters', 4) })
      }]
    },
    $_validateRequired(required, typeField = 'string') {
      const that = this

      return {
        type: typeField,
        required,
        trigger: 'change',
        transform(value) {
          let valueParse = null
          switch (typeField) {
          case 'number' : {
            valueParse = (value && typeof value === 'number') ? value : (value ? parseFloat(value) : null)
            break
          }
          case 'boolean' : {
            valueParse = (typeof value === 'boolean') ? value : value === 'true'
            break
          }
          default: {
            valueParse = typeField === 'string' ? value?.trim() : value
            break
          }
          }

          return valueParse
        },
        message: that.$t('Validate.Required')
      }
    },
    showNotCorrectMessage(message, title) {
      this.$notice.info({
        title: title || this.$t('Common.PleaseNote'),
        message: message || this.$t('Validate.checkRequiredFelds'),
      })
    }
  }
}
